import { Link } from "react-router-dom";
import { FadeIn } from "@/components/FadeIn";
import { Ornament, Diamond } from "@/components/Ornament";
import { useLanguage } from "@/context/LanguageContext";
import { strings } from "@/i18n";

export default function Home() {
  const { lang } = useLanguage();
  const s = strings.home[lang];

  return (
    <div data-testid="home-page">
      <section className="mx-auto max-w-6xl px-6 pb-24 pt-14 md:px-8 md:pb-32 md:pt-20" data-testid="home-hero">
        <FadeIn>
          <p className="eyebrow text-center" data-testid="hero-eyebrow">
            {s.eyebrow}
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="mx-auto mt-10 max-w-3xl md:mt-14">
            <img
              src="/livret/facade.png"
              alt="Dessin de la façade Roganel, 23 rue des Archives, Paris"
              data-testid="hero-facade-image"
              className="w-full"
            />
          </div>
        </FadeIn>
        <FadeIn delay={0.2}>
          <div className="mx-auto mt-14 max-w-2xl text-center md:mt-20">
            <h1 className="font-serif text-5xl font-medium tracking-[0.3em] text-bordeaux md:text-6xl" data-testid="hero-title">
              ROGANEL
            </h1>
            <div className="mt-10">
              <Ornament />
            </div>
            <p className="mx-auto mt-10 max-w-md font-serif text-xl italic leading-relaxed text-noir/80 md:text-2xl" data-testid="hero-tagline">
              {s.tagline}
            </p>
          </div>
        </FadeIn>
        <FadeIn delay={0.3}>
          <div className="mt-14 text-center md:mt-16">
            <Link to="/notre-histoire" className="btn-outline" data-testid="hero-cta-histoire">
              {s.cta}
            </Link>
          </div>
        </FadeIn>
      </section>

      <section className="border-t border-bordeaux/10 bg-cream/40" data-testid="home-intro">
        <div className="mx-auto max-w-3xl px-6 py-20 md:px-8 md:py-28">
          <FadeIn>
            <div className="flex justify-center">
              <Diamond />
            </div>
            <h2 className="mt-8 text-center font-serif text-3xl font-medium text-noir md:text-4xl" data-testid="intro-title">
              {s.introTitle}
            </h2>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div className="mt-10 space-y-6 text-center font-sans text-base font-light leading-loose text-noir/75 [text-wrap:pretty] md:text-lg" data-testid="intro-text">
              <p>
                {s.p1}
              </p>
              <p>
                {s.p2}
              </p>
              <p>
                {s.p3}
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

    </div>
  );
}
